import React from 'react';
import { baseXUnit, breakpoints, spacing } from '../../styles/theme';
import H from '../elements/H';
import Icon from './Icon';

const Quote: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children
}) => {
  return (
    <div className="root">
      <div className="icon-container">
        <Icon name="travel-quote" size={[4, 4, 7]} color="gray" />
      </div>
      <div className="content">
        <H styling="h3" tag="div">
          {children}
        </H>
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .root {
          display: flex;
        }
        .root > :global(.h1) {
          flex-shrink: 0;
          width: ${spacing.four};
        }
        .icon-container {
          margin-right: ${baseXUnit(1.5)};
        }
        .content {
          padding-top: ${baseXUnit(1)};
        }
        @media ${breakpoints.large} {
          .content {
            padding-top: ${baseXUnit(2)};
          }
        }
      `}</style>
    </div>
  );
};

export default Quote;
